import { Ability } from '@casl/ability'
import { initialAbility } from './config'
import provider from '@/store'

const { userData } = provider.state.sessions;
const existingAbility = userData ? userData.ability : null

export default new Ability(existingAbility || initialAbility)
